import { render, staticRenderFns } from "./kafala.vue?vue&type=template&id=d9cba74e&"
import script from "./kafala.vue?vue&type=script&lang=js&"
export * from "./kafala.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports